import { jsx as _jsx } from "react/jsx-runtime";
import { useUITranslation } from "@vertesia/ui/i18n";
import { ConfirmModal } from "./ConfirmModal.js";
import { useToast } from "../../toast/index.js";
export function DeleteModal({ idToDelete, title, content, setIdToDelete, deleteApi }) {
    const { t } = useUITranslation();
    const toast = useToast();
    const doDelete = async () => {
        if (!idToDelete) {
            return;
        }
        return deleteApi(idToDelete)
            .then(() => {
            toast({
                title: t('modal.delete.succeeded'),
                status: 'success'
            });
        }).catch((err) => {
            toast({
                title: t('modal.delete.failed'),
                description: err.message ?? t('modal.delete.error'),
                status: 'error'
            });
        }).finally(() => {
            setIdToDelete(undefined);
        });
    };
    return (_jsx(ConfirmModal, { title: title, content: content, isOpen: !!idToDelete, onConfirm: doDelete, onCancel: () => { setIdToDelete(undefined); } }));
}
//# sourceMappingURL=DeleteModal.js.map